import { computed, type ComputedRef } from 'vue'
import { useApiClient, useQuery } from '@fusapp-work/shell'
import { useCurrentSession } from '../../composables/useCurrentSession'
import { createNavigationSummaryApi } from './navigationSummary'

/** One abortable, principal-and-organization scoped request supplies navigation counts. */
export function useConsoleNavigationCounts(principal: ComputedRef<string | undefined>, organizationId: ComputedRef<string | undefined>) {
  const { state } = useCurrentSession()
  const api = createNavigationSummaryApi(useApiClient())
  return useQuery({
    queryKey: computed(() => ['console', principal.value, 'navigation-summary', organizationId.value]),
    queryFn: ({ signal }) => api.get(organizationId.value!, signal),
    enabled: computed(() => Boolean(principal.value && organizationId.value && state.session?.roles.includes('System_Admin'))),
    retry: false, staleTime: 60_000, refetchOnWindowFocus: false,
  })
}
